module.exports = __webpack_public_path__ + "static/media/close.9a53b46d.svg";